<template>
  <div class="container mt-12">
    <d-table class="pt-5"
             :loading="loading"
             :data="takenTests"
             paginated
             backend-pagination
             :total="total"
             striped
             :per-page="pagination.pageSize"
             default-sort-direction="desc"
             backend-sorting
             :default-sort="[pagination.sortField, pagination.sortOrder]"
             :search.sync="filter"
             show-search
             detailed
             @page-change="page => pagination.page = page"
             @sort="onSort"
    >
      <template #action-buttons>
        <h1 class="text-primary-500 mr-3">
          Taken Tests
        </h1>
      </template>

      <template slot-scope="props">
        <d-table-column field="username" label="User" :row="props.row" />
        <d-table-column field="testType" label="Test Type" :row="props.row" />
        <d-table-column field="startDateTime" label="Start Date">
          {{ props.row.startDateTime | formatShortDate }}
        </d-table-column>
        <d-table-column field="mustFinishByDateTime" label="Must Finish By">
          {{ props.row.mustFinishByDateTime | formatShortDate }}
        </d-table-column>
        <d-table-column field="completed" label="Completed" :row="props.row" />
        <d-table-column field="passed" label="Passed" :row="props.row" />
        <d-table-column class="text-right">
          <d-tooltip label="View Test Results" class="mr-5">
            <a :href="`/admin/tests/test-results/${props.row.id}`" target="_blank" class="mb-0">
              <d-icon icon="tasks" />
            </a>
          </d-tooltip>
          <d-tooltip label="Edit Test Results">
            <d-icon icon="edit" class="cursor-pointer" @click="showEditTestResultModal(props.row)" />
          </d-tooltip>
        </d-table-column>
      </template>
      <template slot="detail" slot-scope="props">
        <h4>Test Details (will take a moment to load in)</h4> 
        <taken-test-report-detail :test-info="props.row" />
      </template>
    </d-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import EditTestResultModal from './components/EditTestResultModal.vue';
    import debounce from 'lodash/debounce';

  export default {
    parent: true,

    data() {
      return {
        loading: false,
        takenTests: [],
        total: 0,
        filter: '',
        pagination: {
          page: 1,
          pageSize: 25,
          sortField: 'startDateTime',
          sortOrder: 'desc',
        },
      };
    },

    watch: {
      pagination: {
        handler() {
          this.getTestsPaged();
        },
        deep: true,
      },

      filter() {
          this.getTestsDebouncedPaged();
      },
    },

    mounted() {
      this.getTestsPaged();
    },

    methods: {
      async getTestsPaged() {
        const {
          page, pageSize, sortField, sortOrder,
        } = this.pagination;
        const params = [`sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`, `filter=${this.filter}`].join('&');
        this.loading = true;
        const { data } = await axios.get(`/api/taken-tests-report/paged?${params}`);
        this.takenTests = data.resultItems;
        this.total = data.totalRecords;
        this.loading = false;
      },

      getTestsDebouncedPaged: debounce(function () {
          this.getTestsPaged();
      }, 500),


      showEditTestResultModal(testResult) {
        this.$modal.open({
          parent: this,
          width: 700,
          component: EditTestResultModal,
          hasModalCard: true,
          props: {
            testResult,
          },
          events: {
            getTestsPaged: () => this.getTestsPaged(),
          },
        });
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },
    },
  };
</script>